// extracted by mini-css-extract-plugin
module.exports = {"order-summary-container":"OrderSummary_order-summary-container__7NrA1","button-solid":"OrderSummary_button-solid__GJtTU","button-primary":"OrderSummary_button-primary__a3bEQ"};